import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '../../features/dashboard/DashboardPage'
import { queryClient } from '../../lib/query-client'
import { dashboardStatsQueryKey } from '../../features/dashboard/hooks/useDashboardStats'
import { api } from '../../lib/api'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: DashboardPage,
  loader: () => {
    // E19-S08: Prefetch dashboard stats before the route renders
    void queryClient.ensureQueryData({
      queryKey: dashboardStatsQueryKey,
      queryFn: ({ signal }) =>
        api('/v1/dashboard/stats', { signal }),
      staleTime: 5 * 60 * 1000,
    })
  },
})
